<template>
  <div>
    <div>
      <SkeletonLoader
        class="products-table__header"
        :show-animation="true"
        data-testid="loading-products-header"
      >
        <div
          v-for="index in 3"
          :key="index"
          class="products-table__header-skeleton"
        />
      </SkeletonLoader>
    </div>
    <div>
      <SkeletonLoader
        class="products-table__body"
        :show-animation="true"
        data-testid="loading-products-content"
      >
        <div
          v-for="index in 3"
          :key="index"
          class="products-table__body-skeleton"
        />
      </SkeletonLoader>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: { SkeletonLoader }
})
export default class ProductsTableSkeleton extends Vue {}
</script>
<style lang="less" scoped>
.products-table {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: @size-spacing-x400;
    margin-bottom: @size-spacing-x400;
  }
  &__header-skeleton,
  &__body-skeleton {
    width: 100%;
    border-radius: 8px;
  }
  &__header-skeleton {
    height: 28px;
  }
  &__body-skeleton {
    height: 96px;
  }
  &__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    gap: @size-spacing-x300;
    padding-top: @size-spacing-x300;
    border-top: 1px solid @divider-primary;
  }
}
</style>
